import classNames from "classnames";
import { CmsImageForUrl } from 'src/components/images/CmsImageForUrl';
import cssPosterStyles from "src/components/posterrow/CSSPoster.module.css";
import PlaySvg from 'src/components/svg/PlaySvg';
import { MovieClip } from 'src/lib/movieinfo/movieinfotypes';
import styles from "./TrailerPoster.module.css";

//#region [Props]
type TrailerPosterProps = {
    movieClip: MovieClip;
    className?: string;
};
//#endregion

//#region [Component]
export default function TrailerPoster({ movieClip, className }: TrailerPosterProps) {
    return <article className={classNames(className, cssPosterStyles.CSSPoster, styles.SArticle)}>
        <div className={classNames(className, cssPosterStyles.CSSPosterWrapper, cssPosterStyles.CSSPosterMissing)}>
            <a className={cssPosterStyles.CSSPosterSizer} href={`#trailer${movieClip.id}`}>
                <PlaySvg className={styles.SPlaySvg} />
                <CmsImageForUrl imageUrl={movieClip.sanityImagePosterUrl!} alt={`Plakat for ${movieClip.movieTitle}`} width={227} unoptimized isPosterAspect />
            </a>
        </div>
        <h1><a href={`#trailer${movieClip.id}`}>{movieClip.movieTitle}</a></h1>
    </article>;
}
//#endregion
